import React from 'react';
import classNames from 'classnames';
import Style from './FJExportProgress.module.less';
import FJProgress from "./FJProgress";

function FJExportProgress(props){

    const {isShow, progress, title, desc, note} = props;
    const {onClose, onRenderIcon, onRenderCloseIcon} = props;

    return (
        <div className={ classNames( Style.progress, isShow ? Style.show : Style.hide ) }>
            <div className={Style.close} onClick={onClose}>{onRenderCloseIcon()}</div>
            <div className={Style.progress_inner}>
                <div className={Style.progress_num}>{Math.floor((progress * 100)) + '%'}</div>
                <h1 className={Style.title}>{title}</h1>
                <div className={Style.progress_slider}>
                    <FJProgress percent={progress} outerClass={Style.progress__outer}/>
                </div>
                <div className={Style.progress_desc}>{desc}</div>
            </div>
            <div className={Style.progress_note}>
                {onRenderIcon(Style.icon)}
                {note}
            </div>
        </div>
    );
}


export default FJExportProgress
